import { getLabel } from 'developer-docs-source/labels/index';
// @ts-expect-error No types given for file
import LoadingHOC from 'developer-docs-shared-components/lib/hoc/LoadingHOC';
import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import styled from 'styled-components';

// @ts-expect-error No types given for file
import { preventAccessTokenCopyListener } from 'developer-docs-shared-components/utils/accessTokens';
import { getOasDocs, getSpecificationStatus, getSpecificationWithExtensions
// @ts-expect-error No types given for file
} from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';
import Toc from '../Toc';
import APIHeader from './APIHeader';
import SecondaryNav from '../SecondaryNav';
import DeveloperDoc from 'developer-docs-shared-components/modules/Doc/components/DeveloperDoc';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import DocsContent from '../../components/DocsContent';
import { REFERENCE_PAGE_ID, MAX_WIDTH } from './constants';
//@ts-expect-error No types given for file
import { getPublicApiSpec } from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';
import { useScrollHashIntoView } from 'developer-docs-shared-components/hooks/useScrollHashIntoView';
import { BATTLESHIP, GREAT_WHITE, KOALA, OLAF, PANTERA } from 'HubStyleTokens/colors';
import { MAIN_CONTENT_ID } from '../../config/accessibility';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import I18n from 'I18n';
import { fetchPublicApiSpec } from '../../actions/FetchPublicApiAction';
import { useAppDispatch } from '../../reducers';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import LayoutPublic, { SCROLL_CONTAINER_ID } from '../LayoutPublic';
import { CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS, INNER_CARD_PADDING } from 'developer-docs-shared-components/config/cssConstants';
import { apiEndpointsNavConfig } from '../../config/nav/reference/apiEndpoints';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { useGetVersionInfo } from '../../hooks/useVersionInfo';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import useToc from '../../hooks/useToc';
import UIFlex from 'UIComponents/layout/UIFlex';
import { TOC_WIDTH, TOC_WIDTH_NARROW, TOC_RIGHT_OFFSET, articleWidthCss } from '../../utils/css';
import useMDXContent from '../../hooks/useMDXContent';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Padding, in pixels, of Request and Response headings.
 */

const StyledContainer = styled.div.withConfig({
  displayName: "APIReferenceLayout__StyledContainer",
  componentId: "sc-1p4u3vw-0"
})(["margin-top:48px;padding-top:16px;border-top:1px solid ", ";.right-column{border:0;.response-panel{position:relative;.response-header{background:", ";border-radius:", "px ", "px 0 0;border-bottom:1px solid ", ";margin-bottom:0;padding:", "px;}div[role='tablist'],div[role='tabpanel']{background:", ";margin-bottom:0;}div[role='tabpanel']{padding:0;border-radius:0 0 10px 10px;}.expand-icon{position:absolute;right:16px;top:13px;}}.code-sample{h5{background:", ";border-radius:", "px ", "px 0 0;border-bottom:1px solid ", ";color:", ";margin-bottom:0;padding:", "px;padding-right:180px;}.hub-no-code{background:", ";border-radius:0 0 10px 10px;color:", ";padding:16px;margin-bottom:24px !important;}.code-request-header{position:relative;}.code-request-header > div{position:absolute;top:11px;right:22px;}}.namespaced-hack-section{padding-bottom:0 !important;}.schema-tab{padding:0 12px 12px 12px;}}.left-column{border:none;.auth-types{.tag{margin-left:0;margin-right:8px;}}.params{padding-top:24px;border:2px solid ", ";border-radius:", "px;.array-field-items,.params-add-additional-property-button-row{border-width:0 !important;}.params-block{padding:0 16px;", "{padding:0;}}.params-descriptor{", "{padding:", ";}}.params-content{padding:", ";font-size:", ";}h5{padding-left:", "px;margin-bottom:", "px;}button[data-test-id='expand-body-params']{margin-top:16px !important;margin-left:16px;}}}.path-container{border-width:1px 0;position:relative;code{padding-bottom:0;}}.media{font-size:14px;}.doc-separator{margin:7vw 0;}"], GREAT_WHITE, KOALA, INNER_CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS, BATTLESHIP, INNER_CARD_PADDING, KOALA, PANTERA, INNER_CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS, KOALA, OLAF, INNER_CARD_PADDING, PANTERA, OLAF, GREAT_WHITE, INNER_CARD_BORDER_RADIUS, mediaQueries.aboveLaptop, mediaQueries.aboveLaptop, ({
  theme
}) => `${theme.space[200]} ${theme.space[600]}`, ({
  theme
}) => `
        ${theme.space[400]} ${theme.space[600]} ${theme.space[400]} 0`, ({
  theme
}) => theme.typography['body-100'].fontSize, INNER_CARD_PADDING, INNER_CARD_PADDING);
const Article = styled.article.withConfig({
  displayName: "APIReferenceLayout__Article",
  componentId: "sc-1p4u3vw-1"
})(["border-radius:", "px;padding:", "px 0;", ""], CARD_BORDER_RADIUS, INNER_CARD_PADDING, articleWidthCss);
const StickyInnerWrapper = styled.div.withConfig({
  displayName: "APIReferenceLayout__StickyInnerWrapper",
  componentId: "sc-1p4u3vw-2"
})(["", "{position:sticky;top:0;right:0;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));
const StickyWrapper = styled(props => /*#__PURE__*/_jsx(StickyInnerWrapper, {
  children: /*#__PURE__*/_jsx("nav", Object.assign({}, props))
})).withConfig({
  displayName: "APIReferenceLayout__StickyWrapper",
  componentId: "sc-1p4u3vw-3"
})(["", "{position:absolute;top:0;width:", "px;right:0;mask-image:linear-gradient(180deg,#000 95%,transparent);max-height:calc(100vh - 100px);overflow-y:auto;padding-bottom:32px;&::-webkit-scrollbar{display:none;}}", "{right:", "px;width:", "px;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT), TOC_WIDTH_NARROW, mediaQueries.aboveLaptop, TOC_RIGHT_OFFSET, TOC_WIDTH);
const ApiReference = ({
  apiKey,
  apiPath,
  loadingStatus,
  oasDocs,
  specWithExtensions
}) => {
  const title = getLabel(apiKey) || '';
  const dispatch = useAppDispatch();
  const locale = useLocale();
  const publicApiSpecInfo = useSelector(getPublicApiSpec);
  const {
    version,
    versions
  } = useGetVersionInfo(apiKey);

  /** Set metadata for SEO */
  const titleParams = ['developer-docs-ui.htmlTitles.apiReference', {
    apiName: title ? `${title}${version ? ` - ${version.versionName}` : ''}` : ''
  }];
  const {
    mdx,
    loading,
    mdxError
  } = useMDXContent({
    ctxKey: apiKey,
    locale
  });
  useMetadata({
    title: I18n.text(...titleParams),
    description: publicApiSpecInfo && publicApiSpecInfo['x-hubspot-introduction'] || version && version.isLegacy && version.intro || '',
    // If the version is not legacy, then it is an openapi spec and we should set this to true
    isContentLoaded: !!mdx || version && !version.isLegacy,
    versionName: version === null || version === void 0 ? void 0 : version.versionName
  });
  const {
    toc,
    setSwitchToc
  } = useToc({
    loadingStatus,
    oasDocs,
    version,
    mdx
  });
  useEffect(() => {
    const specInfo = version && !version.isLegacy && {
      group: version.group,
      name: version.name,
      openApi: version.openApi
    };
    if (!(version !== null && version !== void 0 && version.isLegacy)) {
      dispatch(fetchPublicApiSpec(specInfo || undefined, apiPath, locale));
    }
  }, [apiPath, dispatch, locale, version]);
  useEffect(() => {
    document.addEventListener('copy', preventAccessTokenCopyListener);
    return () => {
      document.removeEventListener('copy', preventAccessTokenCopyListener);
    };
  }, []);
  useEffect(() => {
    const navConfig = apiEndpointsNavConfig();
    getUsageTracker().track('pageView', {
      screen: 'apiReferencePage',
      subscreen: apiKey.replace(navConfig.commonPath, '')
    });
  }, [apiKey]);
  const renderError = () => {
    const details = loadingStatus.get('errorDetails');
    const markerName = `${REFERENCE_PAGE_ID}_PAGE_ERROR`;
    return /*#__PURE__*/_jsx(NavMarker, {
      name: markerName,
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        type: (details === null || details === void 0 ? void 0 : details.status) === 404 ? 'notFound' : 'badRequest',
        children: (details === null || details === void 0 ? void 0 : details.status) === 404 && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-ui.notFound.apiReference"
          })
        })
      })
    });
  };
  useScrollHashIntoView(MAIN_CONTENT_ID);
  return /*#__PURE__*/_jsxs(LayoutPublic, {
    maxContentWidth: MAX_WIDTH,
    sideNavComponent: /*#__PURE__*/_jsx(SecondaryNav, {
      navConfig: apiEndpointsNavConfig()
    }),
    children: [/*#__PURE__*/_jsx(StickyWrapper, {
      children: /*#__PURE__*/_jsx(Toc, {
        containerId: SCROLL_CONTAINER_ID,
        toc: toc,
        activeHeaderBufferWidth: 125
      })
    }), /*#__PURE__*/_jsxs(Article, {
      "data-layout": "3-column",
      children: [/*#__PURE__*/_jsx(APIHeader, {
        apiKey: apiKey,
        versions: versions,
        selectedVersion: version,
        setSwitchToc: setSwitchToc
      }), /*#__PURE__*/_jsx(StyledContainer, {
        children: version !== null && version !== void 0 && version.isLegacy ? loading ? /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          justify: "center",
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
        }) : mdxError ? /*#__PURE__*/_jsx(NavMarker, {
          name: `${REFERENCE_PAGE_ID}_PAGE_ERROR`,
          children: /*#__PURE__*/_jsx(UIFlex, {
            align: "center",
            justify: "center",
            children: /*#__PURE__*/_jsx(UIErrorMessage, {
              type: "badRequest",
              "data-test-id": "mdx-error"
            })
          })
        }) :
        /*#__PURE__*/
        /*
        Do not set the metadata title for legacy api docs, want the title to be consistent between the legacy and non-legacy docs
        */
        _jsx(NavMarker, {
          name: `${REFERENCE_PAGE_ID}_PAGE_LOAD`,
          children: /*#__PURE__*/_jsx(DocsContent, {
            isNonStandardDoc: true,
            ctxKey: "",
            mdx: mdx
          })
        }) : /*#__PURE__*/_jsx(LoadingHOC, {
          statuses: [loadingStatus],
          error: renderError(),
          children: /*#__PURE__*/_jsx(NavMarker, {
            name: `${REFERENCE_PAGE_ID}_PAGE_LOAD`,
            children: /*#__PURE__*/_jsx(DeveloperDoc, {
              oasDocs: oasDocs,
              specWithExtensions: specWithExtensions,
              headerId: MAIN_CONTENT_ID,
              usageTracker: getUsageTracker()
            })
          })
        })
      })]
    })]
  });
};
const mapStateToProps = state => {
  return {
    loadingStatus: getSpecificationStatus(state),
    oasDocs: getOasDocs(state),
    specWithExtensions: getSpecificationWithExtensions(state)
  };
};
export default connect(mapStateToProps)(ApiReference);